import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inbox from "@/pages/Inbox";
import Automation from "@/pages/Automation";
import Settings from "@/pages/Settings";
import Report from "@/pages/Report";
import Privacy from "@/pages/Privacy";
import DataDeletion from "@/pages/DataDeletion";

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <div className="h-screen grid place-items-center text-slate-500 text-sm">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/eliminazione-dati" element={<DataDeletion />} />
          <Route path="/eliminazione dati" element={<DataDeletion />} />
          <Route path="/eliminazione_dati" element={<DataDeletion />} />
          <Route path="/eliminazionedati" element={<DataDeletion />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          <Route element={<Protected><AppShell /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/report" element={<Protected admin><Report /></Protected>} />
            <Route path="/automazione" element={<Protected admin><Automation /></Protected>} />
            <Route path="/impostazioni" element={<Protected admin><Settings /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
